export const customDimensions = {
  storeId: 'dimension1',
  employeeId: 'dimension2',
  startDate: 'dimension3',
  endDate: 'dimension4',
}

export const customMetrics = {
}

export const eventCategories = {
  report: 'Report',
  notification: 'Notification',
  browserTab: 'Browser Tab',
  package: 'Package',
  packageFixFlow: 'Package Fix Flow',
  product: 'Product',
  productLabelQRCode: 'Product Label QRCode',
  webVitals: 'Web Vitals',
  demo: 'Demo',
  packageChangeLog: 'Package Change Log',
}

export const eventActions = {
  viewed: 'Viewed',
  downloaded: 'Downloaded',
  generated: 'Generated',
  changed: 'Changed',
  synced: 'Synced',
  assignedProduct: 'Assigned Product',
  assignedPackage: 'Assigned Package',
  filtered: 'Filtered',
  started: 'Started',
  printed: 'Printed',
  set: 'Set',
  created: 'Created',
  canceled: 'Canceled',
  finished: 'Finished',
}
